import request from '@/utils/request'

// 获取字典数据下拉框列表
export function GetDictionaryData(typeId) {
	return request({
		url: `/api/webapi/data/${typeId}`,
		method: 'GET'
	})
}

// 获取国家下拉框列表
export function GetCountry() {
	return request({
		url: `/api/base/Country/GetAll`,
		method: 'GET'
	})
}

// 获取默认收款银行信息
export function GetDefaultBank() {
	return request({
		url: `/api/fin/BankAccount/Default`,
		method: 'GET'
	})
}

// 获取系统配置
export function GetSysConfig() {
	return request({
		url: `/api/webapi/config/info`,
		method: 'GET'
	})
}